import { useMemo } from "react";
import {
  getPortfolioVideoLimit,
  getUserEntitlements,
  userHasEntitlement,
} from "../config/plans";

export default function useEntitlements(userData) {
  const entitlements = useMemo(() => getUserEntitlements(userData), [userData]);

  const hasEntitlement = (key) => userHasEntitlement(userData, key);

  return {
    entitlements,
    hasEntitlement,
    portfolioVideoLimit: getPortfolioVideoLimit(userData),
  };
}
